import React from 'react'
import SearchResultProvider from './index.provider'
import SearchResultContent from './index.content'

const SearchResultScreen: React.FC = () => {
  return (
    <SearchResultProvider>
      <SearchResultContent />
    </SearchResultProvider>
  )
}

export default SearchResultScreen
